module.exports = __webpack_public_path__ + "static/amith-56caece6af61e91d82095bb66fac9d67.jpg";